import i18next from 'i18next'
import { OrderItemType, ProductStatus, ProductType } from '../enums'

export function translateProductType(type: ProductType) {
  switch (type) {
    case ProductType.SMART_ELECTRICAL_CABINET:
      return i18next.t('smartElectricalCabinet', { ns: 'manufacturing' })
    case ProductType.INSTALLATION_KIT:
      return i18next.t('installationKit', { ns: 'manufacturing' })
    case ProductType.PLUG_AND_PLAY:
      return i18next.t('plugAndPlay', { ns: 'manufacturing' })
    case ProductType.SPINE_MODULE:
      return i18next.t('spineModule', { ns: 'manufacturing' })
    case ProductType.VALVE:
      return i18next.t('valve', { ns: 'manufacturing' })
    case ProductType.RUUVI_TAG:
      return i18next.t('ruuviTag', { ns: 'manufacturing' })
    case ProductType.AURORA:
      return i18next.t('aurora', { ns: 'manufacturing' })
    default:
      return type
  }
}

export function translateProductStatus(status: ProductStatus): string {
  return i18next.t(`ProductStatus.${status}`, { ns: 'manufacturing' })
}

export function productTypeToOrderItemType(type: ProductType) {
  switch (type) {
    case ProductType.INSTALLATION_KIT:
      return OrderItemType.INSTALLATION_KIT
    case ProductType.PLUG_AND_PLAY:
      return OrderItemType.PLUG_AND_PLAY
    case ProductType.SMART_ELECTRICAL_CABINET:
      return OrderItemType.SMART_ELECTRICAL_CABINET
    case ProductType.SPINE_MODULE:
      return OrderItemType.SPINE_MODULE
    case ProductType.VALVE:
      return OrderItemType.VALVE
    case ProductType.RUUVI_TAG:
      return OrderItemType.RUUVI_TAG
    case ProductType.AURORA:
      return OrderItemType.AURORA
  }
}
